import { type ChangeEvent } from "react";
import useEvent from "react-use-event-hook";

import { parseLiveMapHoursInput } from "./live-map.hours-number-field.utils";

export const useLiveMapHoursNumberField = ({
  value,
  onChange,
}: {
  value: number;
  onChange: (value: number | undefined) => void;
}) => {
  const stateContainer = { value };

  const handleChange = useEvent(
    (event: ChangeEvent<HTMLInputElement>): void => {
      const raw = event.target.value;
      if (raw === "") {
        onChange(undefined);
        return;
      }

      const parsed = parseLiveMapHoursInput(raw);
      if (parsed !== undefined) {
        onChange(parsed);
      }
    },
  );

  const increment = useEvent((): void => {
    onChange(stateContainer.value + 1);
  });

  const decrement = useEvent((): void => {
    if (stateContainer.value > 0) {
      onChange(stateContainer.value - 1);
    }
  });

  return {
    handleChange,
    increment,
    decrement,
    isDecrementDisabled: value <= 0,
  };
};
